import React from 'react';
import classNames from 'classnames';

import css from './AvailabilityBadge.module.css';

/**
 * Small colored badge showing a listing's "Disponibilité" (availability) status.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to component's own css.root
 * @param {string?} props.rootClassName overwrite components own css.root
 * @param {string} props.label the text to display, e.g. "Disponible aujourd'hui"
 * @param {boolean} props.isAvailable true renders the "available" (green) style, false the "unavailable" (red) style
 * @returns {JSX.Element} availability badge
 */
const AvailabilityBadge = props => {
  const { className, rootClassName, label, isAvailable } = props;
  const classes = classNames(rootClassName || css.root, className, {
    [css.available]: isAvailable,
    [css.unavailable]: !isAvailable,
  });

  return <span className={classes}>{label}</span>;
};

export default AvailabilityBadge;
